export const buildVersion = __OSLC_BUILD_VERSION__
